export default __webpack_public_path__ + "static/media/key-horizontal-ghost.26b64166.svg";